import React from "react";

const AddForIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.61011 23.5306V9.64583C3.61011 6.36188 6.27472 3.69727 9.55867 3.69727H12.9578"
        stroke="currentColor"
        stroke-width="0.995037"
        stroke-miterlimit="10"
      />
      <path
        d="M23.4436 8.11719V20.0143C23.4436 22.4341 21.4703 24.4073 19.0506 24.4073H9.02588"
        stroke="currentColor"
        stroke-width="0.995037"
        stroke-miterlimit="10"
      />
      <path
        d="M6.48718 14.5547L21.3873 14.5445"
        stroke="currentColor"
        stroke-width="0.995037"
        stroke-miterlimit="10"
      />
      <path
        d="M13.967 7.08891L13.9364 22.0094"
        stroke="currentColor"
        stroke-width="0.995037"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default AddForIcon;
